import React, { useContext } from 'react';
import { Badge } from 'antd';

import DecommissioningReportContext from '@totem/components/salesOrders/decommissioning/DecommissioningReportContext';
import DecommissioningReportFilters from '@totem/components/salesOrders/decommissioning/DecommissioningReportFilters';
import DecommissioningReportTable from '@totem/components/salesOrders/decommissioning/DecommissioningReportTable';

export const DecommissioningReportExtra = () => {
  const { totalRecords } = useContext(DecommissioningReportContext);
  return (
    <Badge count={totalRecords} overflowCount={9999} offset={[0, -7]}>
      Services Not On Contract&nbsp;&nbsp;
    </Badge>
  );
};

const DecommissioningReportLayout = () => (
  <>
    <DecommissioningReportFilters />
    <DecommissioningReportTable />
  </>
);

export default DecommissioningReportLayout;
